<template>
  <div id="afdc-about-the-data" class="afdc-modal-box" v-show="modalOpen" v-on-clickaway="closeAboutTheData">
    <div class="afdc-modal-closer" v-on:click="closeAboutTheData"><span class="afdc-sr-only">{{ $t('Close') }}</span><font-awesome-icon icon="times-circle" class="afdc-fa-icon"/></div>

    <h2>{{ $t('About the Alternative Fueling Station Data') }}</h2>

    <p>{{ $t('Learn about the station location data collection methods, update schedules, and station details.') }}</p>

    <ul class="afdc-nav afdc-nav-tabs" id="afdc-about-the-data-tabs" role="tablist">
      <li class="afdc-nav-item">
        <a id="afdc-about-the-data-us-tab" href="#afdc-about-the-data-us" role="tab" aria-controls="afdc-about-the-data-us" v-on:click.prevent="clickTab('US')" v-bind:class="{ 'afdc-nav-link': true, 'afdc-active': isTabActiveUs }" v-bind:aria-selected="isTabActiveUs ? 'true' : 'false'">{{ $t('United States') }}</a>
      </li>
      <li class="afdc-nav-item">
        <a id="afdc-about-the-data-ca-tab" href="#afdc-about-the-data-ca" role="tab" aria-controls="afdc-about-the-data-ca" v-on:click.prevent="clickTab('CA')" v-bind:class="{ 'afdc-nav-link': true, 'afdc-active': isTabActiveCa }" v-bind:aria-selected="isTabActiveCa ? 'true' : 'false'">{{ $t('Canada') }}</a>
      </li>
    </ul>
    <div class="afdc-tab-content" id="afdc-about-the-data-tabs-content">
      <div id="afdc-about-the-data-us" role="tabpanel" aria-labelledby="afdc-about-the-data-us-tab" v-bind:class="{ 'afdc-tab-pane': true, 'afdc-show': isTabActiveUs, 'afdc-active': isTabActiveUs }">
        <about-the-data-content country="US" />
      </div>
      <div id="afdc-about-the-data-ca" role="tabpanel" aria-labelledby="afdc-about-the-data-ca-tab" v-bind:class="{ 'afdc-tab-pane': true, 'afdc-show': isTabActiveCa, 'afdc-active': isTabActiveCa }">
        <about-the-data-content country="CA" />
      </div>
    </div>
  </div>
</template>

<script>
import AboutTheDataContent from '@/components/AboutTheDataContent.vue';
import { mixin as clickaway } from 'vue-clickaway';

export default {
  name: 'AboutTheData',

  components: {
    AboutTheDataContent,
  },

  mixins: [
    clickaway,
  ],

  data() {
    return {
      activeTab: null,
    };
  },

  computed: {
    modalOpen() {
      return this.$store.getters.getAboutModalOpen;
    },

    isTabActiveUs() {
      return this.activeTab === 'US';
    },

    isTabActiveCa() {
      return this.activeTab === 'CA';
    },
  },

  watch: {
    modalOpen: 'toggleModal',
  },

  methods: {
    toggleModal() {
      if (this.modalOpen) {
        const country = this.$store.getters.getCountry;
        const { localeCountry } = this.$store.getters;
        this.activeTab = (country === 'all') ? localeCountry : country;
      }
    },

    clickTab(tab) {
      this.activeTab = tab;
    },

    closeAboutTheData() {
      if (this.$store.getters.getAboutModalLinkClicked) {
        this.$store.commit('setAboutModalLinkClicked', false);
      } else {
        if (this.$route.query.show_about) {
          this.$router.push({ query: { ...this.$route.query, show_about: undefined } });
        }
        this.$store.commit('setAboutModalOpen', false);
      }
    },
  },
};
</script>

<style lang="scss">
@import '~bootstrap/scss/_functions.scss';
@import '~bootstrap/scss/_variables.scss';

#about-the-data {
  width: 75%;
  max-width: 1000px;
  height: calc(100vh - 60px);
  max-height: 700px;

  .modal-closer {
    margin-left: calc(75% - 55px);
  }

  @media (min-width: 1335px) {
    .modal-closer {
      margin-left: calc(1000px - 55px);
    }
  }

  .nav-tabs {
    border-color: #bbb;
    margin-bottom: 0.5em;

    .nav-item {
      margin-left: 20px;
    }

    .nav-link {
      color: $body-color;
      background-color: #ececec;
      border-bottom-color: #bbb;
    }

    .nav-link.active {
      background-color: transparent;
      border-color: #bbb #bbb #fff #bbb;
    }
  }

  .tab-content ul {
    margin-left: 40px;
  }
}
</style>
